module.exports = __webpack_public_path__ + "static/media/restaurant.6d12dbe4.jpeg";